var PRIMEServicesT2D = angular.module("PRIMEServicesT2D", ["ngResource"]);






PRIMEServicesT2D.factory("CohortT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/cohorts/:cohortId", {cohortId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesT2D.factory("DefaultCohortsT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/cohorts/defaults/:cohortId", {cohortId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true}
		});
	}
]);

PRIMEServicesT2D.factory("DefaultCohortT2D", [function() {
	return {
		name:"New T2D cohort",
		note:"",
		version:1,
		project:null,
		references:"Hayes et al. UKPDS outcomes model 2: a new version of a model to simulate lifetime health outcomes of patients with type 2 diabetes mellitus using data from the 30 year United Kingdom Prospective Diabetes Study: UKPDS 82. Diabetologia. 2013;56(9):1925-33. ",
		male:{
			proportion:54.1
		},
		isCollegeEducationOrAbove:{
			proportion:25.97
		},
		smoker:{
			proportion:18.4
		},
		age:{
			mean:26.7,
			sd:7.1
		},
		white:{
			proportion:100.0,
		},
		black:{
			proportion:0.0,
		},
		hispanic:{
			proportion:0.0,
		},
		southEastAsian:{
			proportion:0.0,
		},
		indian:{
			proportion:0.0,
		},
		otherrace:{
			proportion:0.0,
		},
		durationOfDiabetesAtBaseline:{
			mean:1,
			sd:0.3
		},
		hbA1c:{
			mean:8.2,
			sd:1.5
		},
		sBP:{
			mean:143,
			sd:20
		},
		tChol:{
			mean:5.0,
			sd:1.6
		},
		lDL:{
			mean:3.0,
			sd:0.6
		},
		hDL:{
			mean:1.19,
			sd:0.30
		},
		bMI:{
			mean:30.5,
			sd:6
		},
		eGFR:{
			mean:77.5,
			sd:15
		},
		wBC:{
			mean:6.8,
			sd:1.8
		},
		heartRate:{
			mean:72,
			sd:12
		},
		haem:{
			mean:14.5,
			sd:1.42
		},
		atfib:{
			proportion:0
		},
		mmalb:{
			proportion:0
		},
		pvd:{
			proportion:0
		},
		myocardialInfarctAtBaseline:{
			proportion:0
		},
		strokeAtBaseline:{
			proportion:0
		},
		ischemicHeartDiseaseAtBaseline:{
			proportion:0
		},
		revascularization:{
			proportion:0
		},
		heartFailureAtBaseline:{
			proportion:0
		},
		ulcerAtBaseline:{
			proportion:0
		},
		amputationAtBaseline:{
			proportion:0
		},
		blindnessAtBaseline:{
			proportion:0
		},
		renalFailureAtBaseline:{
			proportion:0
		},
		neuropathyAtBaseline:{
			proportion:0
		},
		obesity: {
			chronicLowerBackPainAtBaseline: {
				proportion: 0
			},
			kneeOsteoarthritisAtBaseline: {
				proportion: 0
			},
			postTotalKneeReplacementAtBaseline: {
				proportion: 0
			},
			steatoticLiverDiseaseAtBaseline: {
				proportion: 0
			}
		}
	}
}])





PRIMEServicesT2D.factory("TreatmentT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/treatments/:treatmentId", {treatmentId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesT2D.factory("DefaultTreatmentT2D", function() {
		return {
			name : "New T2D treatment",
			notes : "",
			version:1,
			project:null,
			references:"",
			depth : 0,
			treatmentEffects : {
				HBA1C : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				SBP : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				BMI : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				HDL : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				LDL : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				EGFR : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				WBC : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				},
				HAEM : {
					distribution : "NORMAL",
					mean : 0.0,
					median : 0.0,
					min : 0.0,
					max : 0.0,
					sd : 0.0,
					se : 0.0,
					n : 0.0,
					ci95L : 0.0,
					ci95U : 0.0,
					crI95L : 0.0,
					crI95U : 0.0
				}
			},
			targetHbA1c:7.5,
			proportionOfPatientsWithConvergingHbA1c:0,
			numberOfYearsToTarget:7,
			changeInHbA1cTargetAfterSevereHypoglycemicEvent:0.15,
			annualIncreaseInHbA1cTargetByAge:0.05,
			hbA1cTargetIncreaseAgeThreshold:40,
			
			hbA1cProgression:"FLAT",
			hbA1cAnnualChange:0,
			sBPProgression:"FLAT",
			sBPAnnualChange:0,
			bMIProgression:"FLAT",
			bMIAnnualChange:0,
			hDLProgression:"FLAT",
			hDLAnnualChange:0,
			lDLProgression:"FLAT",
			lDLAnnualChange:0,
			eGFRProgression:"ZOPPINI",
			eGFRAnnualChange:0,
			wBCProgression:"FLAT",
			wBCAnnualChange:0,
			hRProgression:"FLAT",
			hRAnnualChange:0,
			hBProgression:"FLAT",
			hBAnnualChange:0,
			mIHazardRatio : {
				distribution : "NORMAL",
				mean : 1.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			strokeHazardRatio : {
				distribution : "NORMAL",
				mean : 1.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			cVDDeathHazardRatio : {
				distribution : "NORMAL",
				mean : 1.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			hFHazardRatio : {
				distribution : "NORMAL",
				mean : 1.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			revascularizationHazardRatio : {
				distribution : "NORMAL",
				mean : 1.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			treatmentEffectDuration : 0,
			annualCostYear1 : 100,
			annualCostYear2Onwards : 100,
			switchCondition: null,
			annualQoLDecrementYear1 : 0,
			annualQoLDecrementYear2Onwards : 0,
			hypoglycemiaOption : 1,
			annualNonSevereDaytimeHypoRate : {
				distribution : null,
				mean : 0.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			annualNonSevereNocturnalHypoRate : {
				distribution : null,
				mean : 0.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			},
			annualSevereHypoRate : {
				distribution : null,
				mean : 0.0,
				median : 0.0,
				min : 0.0,
				max : 0.0,
				sd : 0.0,
				se : 0.0,
				n : 0.0,
				ci95L : 0.0,
				ci95U : 0.0,
				crI95L : 0.0,
				crI95U : 0.0
			}
		}
	}
);

PRIMEServicesT2D.factory("DefaultTreatmentSwitchT2D", function() {
		return {
			"subsequentTreatment": {
				"treatmentEffects" : {
				    "HBA1C" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "SBP" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "BMI" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "HDL" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "LDL" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "EGFR" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "WBC" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    },
				    "HAEM" : {
				      "distribution" : "NORMAL",
				      "mean" : 0.0,
				      "sd" : 0.0
				    }
				  },
				"targetHbA1c":7.5,
				"proportionOfPatientsWithConvergingHbA1c":0,
				"numberOfYearsToTarget":7,
				"changeInHbA1cTargetAfterSevereHypoglycemicEvent":0.15,
				"annualIncreaseInHbA1cTargetByAge":0.05,
				"hbA1cTargetIncreaseAgeThreshold":40,
			
				"hbA1cProgression":"FLAT",
				"hbA1cAnnualChange":0,
				"sBPProgression":"FLAT",
				"sBPAnnualChange":0,
				"bMIProgression":"FLAT",
				"bMIAnnualChange":0,
				"hDLProgression":"FLAT",
				"hDLAnnualChange":0,
				"lDLProgression":"FLAT",
				"lDLAnnualChange":0,
				"eGFRProgression":"ZOPPINI",
				"eGFRAnnualChange":0,
				"wBCProgression":"FLAT",
				"wBCAnnualChange":0,
				"hRProgression":"FLAT",
				"hRAnnualChange":0,
				"hBProgression":"FLAT",
				"hBAnnualChange":0,
	  			"mIHazardRatio" : {
	  				"distribution" : "NORMAL",
	  				"mean" : 1.0,
	  				"sd" : 0.0
	  			},
	  			"strokeHazardRatio" : {
	  				"distribution" : "NORMAL",
	  				"mean" : 1.0,
	  				"sd" : 0.0
	  			},
	  			"cVDDeathHazardRatio" : {
	  				"distribution" : "NORMAL",
	  				"mean" : 1.0,
	  				"sd" : 0.0
	  			},
	  			"hFHazardRatio" : {
	  				"distribution" : "NORMAL",
	  				"mean" : 1.0,
	  				"sd" : 0.0
	  			},
					"revascularizationHazardRatio" : {
						"distribution" : "NORMAL",
						"mean" : 1.0,
						"sd" : 0.0
					},
				"timeOnTreatment": 0,
				"annualCostYear1": 0.0,
				"annualCostYear2Onwards": 0.0,
				"switchCondition": null,
				"annualQoLDecrementYear1": 0,
				"annualQoLDecrementYear2Onwards": 0,
				"underlyingHypoRateCurve": null,
				"annualNonSevereDaytimeHypoRate": {
					"distribution": "NORMAL",
					"mean": 0,
					"sd": 0
				},
				"annualNonSevereNocturnalHypoRate": {
					"distribution": "NORMAL",
					"mean": 0,
					"sd": 0
				},
				"annualSevereHypoRate": {
					"distribution": "NORMAL",
					"mean": 0,
					"sd": 0
				},
				"hypoglycemiaOption": 1
			},
			"switchType":"DURATION",
			"switchThreshold": 0,
			"switchAboveThreshold": false,
			"switchProperty": "BMI",
			"annualProbabilityOfSwitch": null,
			"yearsUntilSwitch": 5
		}
	}
);

PRIMEServicesT2D.factory("SwitchRiskFactorsT2D", function() {
		return [
			{ id:"BMI", name: "Body mass index (kg)" },
			{ id:"EGFR", name: "Estimated glomerular filtration rate (m/min/1.73m2)" }, 
			{ id:"HAEM", name: "Hemoglobin (g/dL)" }, 
			{ id:"HBA1C", name: "HbA1c (%)" },
			{ id:"HDL", name: "HDL cholesterol (mmol/L)" },
			{ id:"LDL", name: "LDL cholesterol (mmol/L)" },
			{ id:"SBP", name: "Systolic blood pressure (mmHg)" },
			{ id:"WBC", name: "White blood cell count (1,000,000 cells/L)" }
		];
	}
);





PRIMEServicesT2D.factory("CostT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/costs/:costId", {costId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesT2D.factory("DefaultCostT2D", [function() {
	return {
		name:"New T2D cost",
		note:"",
		references:"• Yang et al. J Diabetes Complications. 2020; 34(12): 107735 and Yang et al. J Diabetes Complications. 2020; 34(12): 107735\n" +
      "• Ward et al. J Med Econ. 2014; 17(3): 176-83 and Ward et al. J Med Econ. 2014; 17(3): 176-83\n" +
      "• Yang et al. J Diabetes Complications. 2020; 34(12): 107735 and Assumed\n" +
      "• Yang et al. J Diabetes Complications. 2020; 34(12): 107735 and Yeaw et al. Appl Health Econ Health Policy. 2014; 12(2): 219-30\n" +
      "• Bajpai et al. J Manag Care Spec Pharm. 2021; 27(3): 385-91",
		version:1,
		project:null,
		currency:"USD",
		year:2023,
		amputation : {
			eventCost : {
				mean : 29615,
				sD : 0
			},
			stateCost : {
				mean : 1729,
				sD : 0
			}
		},
		ulcer : {
			eventCost : {
				mean : 13080,
				sD : 0
			},
			stateCost : {
				mean : 2542,
				sD : 0
			}
		},
		ischemicHeartDisease : {
			eventCost : {
				mean : 28327,
				sD : 0
			},
			stateCost : {
				mean : 2520,
				sD : 0
			}
		},
		revascularization : {
			eventCost : {
				mean : 24072,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		heartFailure : {
			eventCost : {
				mean : 36949,
				sD : 0
			},
			stateCost : {
				mean : 8363,
				sD : 0
			}
		},
		myocardialInfarct : {
			eventCost : {
				mean : 53586,
				sD : 0
			},
			stateCost : {
				mean : 10151,
				sD : 0
			}
		},
		neuropathy : {
			eventCost : {
				mean : 13629,
				sD : 0
			},
			stateCost : {
				mean : 373,
				sD : 0
			}
		},
		macularEdema : {
			eventCost : {
				mean : 1056,
				sD : 0
			},
			stateCost : {
				mean : 93,
				sD : 0
			}
		},
		stroke : {
			eventCost : {
				mean : 28160,
				sD : 0
			},
			stateCost : {
				mean : 5600,
				sD : 0
			}
		},
		blindness : {
			eventCost : {
				mean : 15389,
				sD : 0
			},
			stateCost : {
				mean : 2816,
				sD : 0
			}
		},
		ckdStage1 : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		ckdStage2 : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		ckdStage3 : {
			eventCost : {
				mean : 105,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		ckdStage4 : {
			eventCost : {
				mean : 144,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		renalFailure : {
			eventCost : {
				mean : 111589,
				sD : 0
			},
			stateCost : {
				mean : 117213,
				sD : 0
			}
		},
		severeHypoglycemia : {
			eventCost : {
				mean : 4503,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereDaytimeHypoglycemia : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereNocturnalHypoglycemia : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : null,
				sD : null
			}
		},
		noComplications : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_65_69_Male : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_65_69_Female : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_70_74_Male : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_70_74_Female : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_75_79_Male : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_75_79_Female : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_80_84_Male : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_80_84_Female : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_85Plus_Male : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		unrelatedMedCost_85Plus_Female : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		chronicLowerBackPain : {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		kneeOsteoarthritis: {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		postTotalKneeReplacement: {
			eventCost : {
				mean : 0,
				sD : 0
			},
			stateCost : {
				mean : 0,
				sD : 0
			}
		},
		indirectCosts: {
			meanAgeAtWorkforceEntry: 0.0,
			meanAgeAtRetirement: 0.0,
			meanSalaryMale: {
				mean: 0.0,
				sD: 0.0
			},
			meanSalaryFemale: {
				mean: 0.0,
				sD: 0.0
			},
			percentageEmployed: 0.0,
			workingDaysPerYear: 0,
			amputation: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			ulcer: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			ischemicHeartDisease: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			heartFailure: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			myocardialInfarct: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			neuropathy: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			stroke: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			blindness: {
				eventTimeOff: {
					mean: 0.0,
					sD: 0.0
				},
				stateTimeOff: {
					mean: 0.0,
					sD: 0.0
				}
			},
			ckdStage1 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			ckdStage2 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			ckdStage3 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			ckdStage4 : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			},
			renalFailure : {
				eventTimeOff : {
					mean : 0,
					sD : 0
				},
				stateTimeOff : {
					mean : 0,
					sD : 0
				}
			}
		},
		indirectCostsActive : false,
    noComplicationCostsActive: false,
		obesity: {
			chronicLowerBackPain : {
				eventCost : {
					mean : 0,
					sD : 0
				},
				stateCost : {
					mean : 0,
					sD : 0
				}
			},
			kneeOsteoarthritis: {
				eventCost : {
					mean : 0,
					sD : 0
				},
				stateCost : {
					mean : 0,
					sD : 0
				}
			},
			postTotalKneeReplacement: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			},
			steatosisF0F2: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			},
			steatosisF3: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			},
			compensatedCirrhosis: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			},
			dccAndHcc: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			},
			liverTransplant: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			},
			postLiverTransplant: {
				eventCost: {
					mean: 0,
					sD: 0
				},
				stateCost: {
					mean: 0,
					sD: 0
				}
			}
		}
	}
}])






PRIMEServicesT2D.factory("UtilityT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/utilities/:utilityId", {utilityId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);

PRIMEServicesT2D.factory("DefaultUtilityT2D", [function() {
	return {
		name:"New T2D utility",
		note:"",
		references: "• Hayes et al. Value Health. 2016; 19(1): 36-41\n" +
      "• Briggs et al. Diabetes Res Clin Pract. 2017; 130: 24-33\n" +
      "• Hayes et al. Value Health. 2016; 19(1): 36-41\n" +
      "• Shao et al. Pharmacoeconomics. 2019; 37(7): 921-929\n" +
      "• Bagust and Beale. Health Econ. 2005; 14(3): 217-30\n" +
      "• Mitchell et al. Br J Ophthalmol. 2012; 96(5): 688-693 (correspond to BCVA change from 76-85 to 66-75)\n" +
      "• Nauck et al. Diabetes Obes Metab. 2019; 21(3): 525-532\n" +
      "• Evans et al. Health Qual Life Outcomes. 2013; 11: 90",
		version:1,
		project:null,
		baselineQoL : {
			0 : {
				mean : 0.820,
				sD : 0.0
			}
		},
		qoLApproach: "ADDITIVE", // ADDITIVE, SHAO
		amputation : {
			eventOrOnsetDisutility : {
				mean : -0.122,
				sD : 0
			},
			stateDisutility : {
				mean : -0.122,
				sD : 0
			}
		},
		ulcer : {
			eventOrOnsetDisutility : {
				mean : -0.023,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		ischemicHeartDisease : {
			eventOrOnsetDisutility : {
				mean : -0.10,
				sD : 0
			},
			stateDisutility : {
				mean : -0.10,
				sD : 0
			}
		},
		revascularization : {
			eventOrOnsetDisutility : {
				mean : -0.038,
				sD : 0
			},
			stateDisutility : {
				mean : -0.016,
				sD : 0
			}
		},
		heartFailure : {
			eventOrOnsetDisutility : {
				mean : -0.065,
				sD : 0
			},
			stateDisutility : {
				mean : -0.065,
				sD : 0
			}
		},
		myocardialInfarct : {
			eventOrOnsetDisutility : {
				mean : -0.051,
				sD : 0
			},
			stateDisutility : {
				mean : -0.051,
				sD : 0
			}
		},
		neuropathy : {
			eventOrOnsetDisutility : {
				mean : -0.066,
				sD : 0
			},
			stateDisutility : {
				mean : -0.066,
				sD : 0
			}
		},
		stroke : {
			eventOrOnsetDisutility : {
				mean : -0.111,
				sD : 0
			},
			stateDisutility : {
				mean : -0.111,
				sD : 0
			}
		},
		blindness : {
			eventOrOnsetDisutility : {
				mean : -0.083,
				sD : 0
			},
			stateDisutility : {
				mean : -0.083,
				sD : 0
			}
		},
		macularEdema : {
			eventOrOnsetDisutility : {
				mean : -0.047,
				sD : 0
			},
			stateDisutility : {
				mean : 0.0,
				sD : 0
			}
		},
		ckdStage1 : {
			eventOrOnsetDisutility : {
				mean : 0.0,
				sD : 0
			},
			stateDisutility : {
				mean : 0.00,
				sD : 0
			}
		},
		ckdStage2 : {
			eventOrOnsetDisutility : {
				mean : 0.0,
				sD : 0
			},
			stateDisutility : {
				mean : 0.00,
				sD : 0
			}
		},
		ckdStage3 : {
			eventOrOnsetDisutility : {
				mean : -0.004,
				sD : 0
			},
			stateDisutility : {
				mean : -0.004,
				sD : 0
			}
		},
		ckdStage4 : {
			eventOrOnsetDisutility : {
				mean : -0.004,
				sD : 0
			},
			stateDisutility : {
				mean : -0.004,
				sD : 0
			}
		},
		renalFailure : {
			eventOrOnsetDisutility : {
				mean : -0.049,
				sD : 0
			},
			stateDisutility : {
				mean : -0.049,
				sD : 0
			}
		},
		severeHypoglycemia : {
			eventOrOnsetDisutility : {
				mean : -0.055,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereDaytimeHypoglycemia : {
			eventOrOnsetDisutility : {
				mean : -0.005,
				sD : 0
			},
			stateDisutility : {
				mean : 0,
				sD : 0
			}
		},
		nonSevereNocturnalHypoglycemia : {
			eventOrOnsetDisutility : {
				mean : -0.007,
				sD : 0
			},
			stateDisutility : null
		},
		obesity: {
			chronicLowerBackPain : {
				eventOrOnsetDisutility : {
					mean : 0.0,
					sD : 0
				},
				stateDisutility : {
					mean : 0.0,
					sD : 0
				}
			},
			kneeOsteoarthritis: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			postTotalKneeReplacement: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			steatosisF0F2: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			steatosisF3: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			compensatedCirrhosis: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			dccAndHcc: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			liverTransplant: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			},
			postLiverTransplant: {
				eventOrOnsetDisutility: {
					mean : 0.0,
					sD : 0
				},
				stateDisutility: {
					mean: 0.0,
					sD : 0
				}
			}
		}
	}
}])






PRIMEServicesT2D.factory("CountryT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/countries/:countryId", {countryId:"@_id"}, {
			get: {method:"GET"},
			query: {method:"GET", isArray:true},
			save: {method:'POST'},
			delete: {method:'DELETE'},
			update: { method:'PUT' }
		});
	}
]);


PRIMEServicesT2D.factory("DefaultCountryT2D", function() {
		return {
			name : "New T2D country",
			note : "",
			version:1,
			project:null,
			costDiscountRate:3,
			effectDiscountRate:3,
			backgroundMortalityOption: "LIFE_TABLES", // LIFE_TABLES, UKPDS_OM2, BRAVO
			complicationSpecificMortalityOptions: "UKPDS_OM2", // OFF, UKPDS_OM2, BRAVO
			mortalityOption: "LIFE_TABLES",
			complicationModeling: "DEFAULT",
			cVDModelAveraging:"WEIGHTED", // WEIGHTED, UNWEIGHTED, or DEFAULT
			renalFailureModel:"EGFR", // EGFR or UKPDS
			iHDModelAveraging:"UKPDS",
			raceModelAveraging:"HKR",
			defaultCVDEquation:1, // Only used when cVDModelAveraging == 2. see cVDModelAveragingOptions in the $rootScope for possible values.
			lifetable:"USA-2019"
		}
	}
);






PRIMEServicesT2D.factory("LifeTableT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/countries/life-tables", {}, {
			get: {method:"GET"}
		});
	}
]);


PRIMEServicesT2D.factory("SimulationServiceT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/simulations/:simulationId", {simulationId:"@_id"}, {
      get:    { method:"GET", params: { fullElements: true } },
      // keep legacy array endpoint (if still used somewhere)
      query:  { method:"GET", isArray:true,  params: { summary: true } },
      // NEW: paged summaries → returns the { items, page, pageSize, total, totalPages } envelope
      queryPaged: {
        method: "GET",
        isArray: false,
        params: { summary: true },
        // $resource will send ?page=&pageSize=&search= we pass from controller
      },
      clone:  { method:"GET", params: { fullElements: true, omitResults: true } },
      rerun:  { method:"POST", url: "api/t2d/simulations/:simulationId/rerun", hasBody: false },
      save:   { method:"POST" },
      delete: { method:"DELETE" },
      update: { method:"PUT" }
    });
	}
]);


PRIMEServicesT2D.factory("QueueServiceT2D", ["$resource",
	function($resource) {
		return $resource("api/t2d/simulations/in-queue", {}, {
			get: {method:"GET"},
		});
	}
]);



PRIMEServices.factory("ICERCalculatorT2D", 
	function ICERCalculatorT2D() {
		
		function icer(simulation, discounted) {
			if (simulation === undefined) {
				return '';
			}

			if (simulation.arms !== undefined && (simulation.arms['0'] === undefined || simulation.arms['0'] === null) && (simulation.arms['1'] === undefined || simulation.arms['1'] === null)) {
				return 'Pending';
			}
			
			if (simulation.arms !== undefined && ((simulation.arms['0'] === undefined || simulation.arms['0'] === null) || (simulation.arms['1'] === undefined || simulation.arms['1'] === null))) {
				return '–';
			}
			
			var comparatorCost = discounted ? simulation.arms["0"].cumulativeDiscountedCost[simulation.arms["0"].cumulativeDiscountedCost.length - 1] : simulation.arms["0"].cumulativeUndiscountedCost[simulation.arms["0"].cumulativeUndiscountedCost.length - 1] ,
				interventionCost = discounted ? simulation.arms["1"].cumulativeDiscountedCost[simulation.arms["0"].cumulativeDiscountedCost.length - 1] : simulation.arms["1"].cumulativeUndiscountedCost[simulation.arms["0"].cumulativeUndiscountedCost.length - 1] ,
				comparatorQALE = discounted ? simulation.arms["0"].cumulativeDiscountedQALE[simulation.arms["0"].cumulativeDiscountedQALE.length - 1] : simulation.arms["0"].cumulativeUndiscountedQALE[simulation.arms["0"].cumulativeUndiscountedQALE.length - 1],
				interventionQALE = discounted ? simulation.arms["1"].cumulativeDiscountedQALE[simulation.arms["0"].cumulativeDiscountedQALE.length - 1] : simulation.arms["1"].cumulativeUndiscountedQALE[simulation.arms["0"].cumulativeUndiscountedQALE.length - 1];
	
			var icer = "";

			if (interventionCost < comparatorCost && interventionQALE > comparatorQALE) {
				icer = "Dominant";
			}

			if (interventionCost > comparatorCost && interventionQALE < comparatorQALE) {
				icer = "Dominated";
			}

			if (interventionCost == comparatorCost) {
				icer = "Same cost";
				if (interventionQALE < comparatorQALE) {
					icer += ", less effective";
				} else if (interventionQALE > comparatorQALE) {
					icer += ", more effective";
				} else {
					icer += ", same effectiveness";
				}
			}

			if (interventionQALE == comparatorQALE) {
				icer = "Same effectiveness";
				if (interventionCost < comparatorCost) {
					icer += ", less costly";
				} else if (interventionCost > comparatorCost) {
					icer += ", more costly";
				} else {
					icer += ", same cost";
				}
			}

			if (icer === "") {
				icer = addCommas(((interventionCost - comparatorCost) / (interventionQALE - comparatorQALE)).toFixed(0));
			}

			return simulation.progress == "Complete" ? icer : "Pending";
		}
		
		return {
			icer : icer
		}
	}
);